! function(ac) {
  
  ac(document).ready(function() {
	 ab.init()
  });
  
  var ab = {
    drawerTimeout: null,
   
    init: function() {
      this.hideDrawer(),this.gridAddToCart(),this.prodAddToCart(),this.removeCartItem(),this.initWishlist(),this.initProductWishlist(),this.hideModal()
    }, 
    getURLParam: function(name){
    	var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    	
      	if(results==null)
        {
       		return null;
   	 	}
    	else {
      	 	return results[1] || 0;
    	}
	},
    gridAddToCart: function() {
      ac(".btnCart").live("click",function(i) {
        
       	  i.preventDefault();
          if(theme.ajax_cart) {
            var att = ac(this).attr("id"),
            	qty = ac(this).attr("rel");
            
			var product_hndle = ac("#product-actions-" + att + " input[name=product_hndle]").val();
            Shopify.Wishlist.removeProduct(product_hndle); 
            
            ab.addinToCart(att, qty);
          } else {
            
            ac(this).parent().submit();
          }
        return;
      });
    },
    prodAddToCart: function() {
      var cartBtn = ac(".product-btn-cart"),
      	  pName = ac("h1.product-single__title").text(),
          pImg = ac(".product-single__photo .product-featured-img").attr("src");

      ac(cartBtn).on("click",function(i) {
        if (i.preventDefault(), "disabled" != ac(this).attr("disabled"))
          if (theme.ajax_cart) {
            var att = ac(".product-form select[name='id']").attr('selected', true).val()
            	att || (att = ac("#add_to_cart_form input[name=id]").val());
            var qty = ac("#add_to_cart_form input[name=quantity]").val();
            	qty || (qty = 1);
            
            ab.addinToCart(att, qty)
          } else {
            ac(".product-form").submit();
          }
         return !1
      })
    },
    onCartUpdate: function(cart) {
      ac.getJSON('/cart.js', function(cart) {
        
        if(Currency.format == "money_format")
        {
      		ac('.cart__subtotal').html(Shopify.formatMoney(Currency.convert(cart.total_price, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format));
        }
        else
        {
            ac('.cart__subtotal').html(Shopify.formatMoney(Currency.convert(cart.total_price, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format)+" "+Currency.currentCurrency);
        }
        
	  });
	},
  	removeCartItem: function() {
  		ac('.cart__remove').on('click', function(i){
   	 			i.preventDefault();
    			var productId = parseInt(ac(this).attr('data-id'));
      			var params2 = {
   					type: 'POST',
    				url: '/cart/change.js',
    				data: 'quantity=0&id='+productId,
    				dataType: 'json',
    				success: function(cart) {
                      
                    //update mini cart  
                    CartJS.updateItemById(productId,0);
                      
      				ac('#cart_row_'+productId).remove();
                      
                     //update cart sub-total 
                     ab.onCartUpdate(cart);
           			
    				},
   					error: function(XMLHttpRequest, textStatus) {
      					Shopify.onError(XMLHttpRequest, textStatus);
    				}
  				};
     	jQuery.ajax(params2);  	
      });
    },
    showLoadingBox: function() {
		ac("body").addClass("loading");
	},
	hideLoadingBox: function() {
		ac("body").removeClass("loading");
    },
  	showDrawer: function(i) {
      ac("body").addClass("showOverly"),ac(i).fadeIn(500), ab.drawerTimeout = setTimeout(function() {
        ac("body").removeClass("showOverly"),ac(i).fadeOut(500)
      }, 5e3)
    },
    hideDrawer: function() {
      ac(".continue-shopping, .modalOverly, .closeDrawer").click(function() {
        clearTimeout(ab.drawerTimeout), ac(this).closest(".modal").fadeOut(500);
        ac("body").removeClass("showOverly");
      }),
      ac(".modalOverly").click(function() {
        clearTimeout(ab.drawerTimeout), ac("#cartDrawer,#cartError").fadeOut(500);
       ac("body").removeClass("showOverly");
      })
    },
    addinToCart: function(att, qty ) {
      
      CartJS.addItem(att, qty, {     
      }, {
          "success": function(data, textStatus, jqXHR){
			 ac("#cartDrawer").find(".modal-prod-img").attr("src", data.image);
             ac("#cartDrawer").find(".modal-prod-img").load(function() {
               ab.hideLoadingBox(),
               ac("#cartDrawer").find(".modal-prod-name").text(data.product_title),
               ac("#cartDrawer").find(".cartText").show(),
               ab.showDrawer("#cartDrawer"); 
               
            });
          },
          "error": function(jqXHR, textStatus, errorThrown){
            var errormsg = JSON.parse(jqXHR.responseText).description;
            ab.hideLoadingBox(),
            ac(".error-message").text(errormsg), ab.showDrawer("#cartError");
          }
      });
    },
    closeDrawer: function() {
    	ac(".closeDrawer").click(function() {
          ab.hideLoading(), ab.hideDrawer();
        })
  	},
    /*** Added for Custom Wishlist ***/
    initWishlist: function() {
       ac(".grid-view-item .btnWishlistAdded,.list-view .btnWishlistAdded").live("click",function(i) {
              i.preventDefault();
              var a = ac(this).parent();
        
              var o;
              var str = ac(this).attr("id");
              var res = str.split("_"); 
              var product_handle = res[1];
              var title_class,image_class;
              var view_value = ab.getURLParam('view');
             
         	   Shopify.Wishlist.StoreProduct(product_handle);
                         
               ac(".loadingBox").hide();
        
         		if(ac(".grid-view-item" ).length > 0)
            	{
           			title_class = ".grid-view-item__title";
                	image_class = ".grid-view-item__image";
               		o = a.parents(".grid-view-item");
                	
           		 }
         
        		if(ac(".list-view-items").length > 0)
       	 		{
                   
                  	title_class = ".list-view-item__title";
                	image_class = ".list-view-item__image";
                	o = a.parents(".list-view");
                	
                  
       			}
         
            
              a.html('<a class="btn btnList wishlist" href="/pages/wish-list" title="Go to wishlist"><i class="fa fa-heart" aria-hidden="true"></i></a>');
              var i = o.find(title_class).text(),
              n = o.find(image_class).attr("src");
              ab.hideLoadingBox(),
           	  ac("#successDrawer").find(".modal-prod-name").text(i),
              ac("#successDrawer").find(".modal-prod-img").attr("src", n),
              ac("#successDrawer").find(".wishlistTxt").show(),
              ab.showDrawer("#successDrawer");     
            })
        },
        initProductWishlist: function() {
            ac(".product-single__meta .btnWishlistAdded").click(function(i) {
             
              i.preventDefault(); 
              
              var str = ac(this).attr("id");
              var res = str.split("_"); 
              var product_handle = res[1];
            
              Shopify.Wishlist.StoreProduct(product_handle);
              
              var a = ac(this).parent();
              
               ac("#btnWishlistAdded_"+product_handle).remove();
               //ac(".wishlistOuter").append('<a class="btn btnList wishlist" href="/pages/wish-list" title="Go to wishlist"><i class="fa fa-heart" aria-hidden="true"></i></a>');
           //ac( '<a class="btn btnList wishlist" href="/pages/wish-list" title="Go to wishlist"><i class="fa fa-heart" aria-hidden="true"></i></a>' ).append( ".wishlistOuter #" );
              ac("#already_wishlist_"+product_handle).show();
              
              var i = ac(".product-single__title").text(),
               n = ac("img[id^='FeaturedImage-']").attr("src");
              
            	ac("#successDrawer").find(".modal-prod-name").text(i),
             	ac("#successDrawer").find(".modal-prod-img").attr("src", n),
            	ac("#successDrawer").find(".wishlistTxt").show(),
             	ab.showDrawer("#successDrawer");    
              
              })
        },
        hideLoading: function() {
            ac(".loadingBox").hide()
        },
    	hideModal: function() {
    	 ac(".continue-shopping, .modalOverly").click(function() {
       	 	clearTimeout(ab.drawerTimeout), ac(this).closest(".modal").fadeOut(500);
        	ac(".modalOverly").fadeOut(500);
     	 }),
      	ac(".modalOverly").click(function() {
        	clearTimeout(ab.drawerTimeout), ac("#successDrawer,#errorDrawer").fadeOut(500);
        	ac(this).fadeOut(500);
      		})
   		} 
  }
}(jQuery);